<template>
  <div class="flex w-full mx-auto px-40 mt-40 mb-65 md:my-40 justify-between items-center flex-wrap lg:flex-no-wrap">
    <!-- View Toggle -->
    <div class="flex items-center justify-center lg:justify-start text-gray700 w-full lg:w-auto mb-25 lg:mb-0">
      <button
          class="py-3 bg-transparent border-b border-solid border-transparent hover:border-gray200 ts-all"
          :class="{ 'border-gray400': view === 'list' }"
          @click="$emit('update:view', 'list')"
      >List</button>

      <div class="w-3px h-3px mx-15 rounded-full bg-gray200"></div>

      <button
          class="py-3 bg-transparent border-b border-solid border-transparent hover:border-gray200 ts-all"
          :class="{ 'border-gray400': view === 'map' }"
          @click="$emit('update:view', 'map')"
      >Map</button>
    </div>

    <!-- Sort -->
    <div class="flex items-center justify-center flex-wrap  lg:flex-no-wrap lg:justify-start w-full lg:w-auto mb-25 lg:mb-0">
      <div class="text-xs font-secondary font-bold uppercase tracking-loose lg:mr-15 w-full lg:w-auto text-center">
        Sort by:
      </div>
      <label class="mr-15 custom-select-borderless">
        <div class="custom-select-wrapper">
          <select
              class="custom-select w-full"
              :value="sortOption"
              @change="$emit('update:sort-option', $event.target.value)"
          >
            <option v-for="option in sortOptions" :key="option.value" :value="option.value">
              {{ option.label }}
            </option>
          </select>
        </div>
      </label>

      <button
          v-if="hasActiveFilters"
          class="text-xs font-secondary font-bold uppercase tracking-loose text-red500 bg-transparent outline-none mt-15 lg:mt-0 lg:ml-20 w-full lg:w-auto"
          type="button"
          @click="$emit('reset-filters')"
      >Reset Filters</button>
    </div>

    <!-- Match Count -->
    <div class="flex w-full lg:w-auto justify-center items-center lg:justify-end">
      <span v-if="matches">{{ matches.toLocaleString() }} Matches</span>
      <span v-else-if="!loading">0 Matches</span>
    </div>
  </div>
</template>

<script>
// Displays brokerage result statistics and list/map sorting controls.
export default {
  props: {
    view: {
      type: String,
      default: 'list'
    },
    sortOptions: {
      type: Array,
      default: () => ([
        { value: 'relevance', label: 'Relevance' },
        { value: 'price_asc', label: 'Price (Low to High)' },
        { value: 'price_desc', label: 'Price (High to Low)' },
        { value: 'sqft_desc', label: 'Sq Ft (High to Low)' },
      ])
    },
    sortOption: {
      type: String,
      default: 'relevance',
    },
    matches: {
      type: Number,
      default: 0,
    },
    loading: { type: Boolean, default: false },
    hasActiveFilters: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['update:view', 'update:sort-option', 'reset-filters'],
}
</script>
